import { ReactNode } from "react";
import AffiliateProduct from "../../Block/AffiliatesProduct/affiliatesProduct";
import styles from "./affiliatesProductCarousell.module.css";
import { useMediaQuery } from "../../../hooks";
import NaturalCarousel, {
  ArrowVariant,
} from "../../Utility/NaturalCarousel/NaturalCarousel";

type AffiliatesProduct = React.ComponentProps<typeof AffiliateProduct>;
type AffiliatesProductCarousellProps = {
  noOfItemsInFrame?: number;
  carouselWidthLeeWay?: number;
  items: AffiliatesProduct["item"][];
  itemWidth: AffiliatesProduct["itemWidth"];
  itemHeight: AffiliatesProduct["itemHeight"];
  cta?: AffiliatesProduct["cta"];
  arrowSize?: number;
  arrowVariant?: ArrowVariant;
  disclaimer?: string;
};

/**
 * AffiliatesProductCarousell, uses product card component to display products in a carousel.
 *
 */
export default function AffiliatesProductCarousell({
  items,
  itemWidth,
  itemHeight,
  cta,
  noOfItemsInFrame,
  carouselWidthLeeWay,
  arrowSize,
  arrowVariant,
  disclaimer,
}: AffiliatesProductCarousellProps): ReactNode {
  const mobileUp = useMediaQuery("screen and (min-width: 1000px)");
  const noOfItems = noOfItemsInFrame ?? 3;
  const leeWay = carouselWidthLeeWay ?? 30;
  const width = mobileUp && itemWidth ? (itemWidth + leeWay) * noOfItems : 290;
  const itemWidthContainer = mobileUp ? itemWidth : 290;

  const enforceDoublePriceLine = items.some((item) => {
    const { discountPrice, originalPrice } = item.dealsSource?.[0] || {};

    return discountPrice && originalPrice;
  });
  return (
    <div className={styles.container}>
      <div
        className={styles.carouselContainer}
        style={{
          width: width + "px",
        }}
      >
        <NaturalCarousel
          isLooping={false}
          showArrowsOnMobile
          arrowSize={arrowSize || 40}
          arrowVariant={arrowVariant}
        >
          {items.map((item, index) => (
            <AffiliateProduct
              cta={cta}
              item={{
                ...item,
                dealsSource: item.dealsSource && item.dealsSource.slice(0, 1),
              }}
              key={index}
              itemWidth={itemWidthContainer}
              itemHeight={itemHeight}
              enforceDoublePriceLine={enforceDoublePriceLine}
            />
          ))}
        </NaturalCarousel>
      </div>
      {disclaimer && <div className={styles.disclaimer}>{disclaimer}</div>}
    </div>
  );
}
